import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '@webcomponents/webcomponentsjs';

import PetScroller from './components/pet-scroller';

async function bootstrap() {}

bootstrap();
